//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('interBranchInvoicing', {
//        templateUrl: 'views/components/views/interBranchInvoicing/interBranchInvoicing.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'interBranchInvoicingService', 'logisticService', 'ttGridFactory', function (stateService, utilityService, interBranchInvoicingService, logisticService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListBusinessCompanies: [],
//                retrieving: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await interBranchInvoicingService.getSetting())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true && utilityService.validateParmsValue(vm.model.setting.businessco_no_from) === true && utilityService.validateParmsValue(vm.model.setting.businessco_no_to) === true && utilityService.validateParmsValue(vm.model.setting.deliverydate_tom) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region RETRIEVE NEW FUNCTION

//            vm.retrieveChanges = function () {
//                vm.model.retrieving = true;

//                interBranchInvoicingService.createNewInvoice(vm.model.setting).then(() => {
//                    vm.model.retrieving = false;
//                    loadGrid();
//                }, () => vm.model.retrieving = false);
//            }

//            // #endregion RETRIEVE NEW FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'interbranchinvoicingmi':
//                        go({
//                            businessco_no_from: vm.model.setting.businessco_no_from,
//                            businessco_no_to: vm.model.setting.businessco_no_to
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no_from':
//                    case 'businessco_no_to':
//                    case 'deliverydate_tom':
//                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

//                        vm.model.setting[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
